export default __webpack_public_path__ + "static/media/obj_unselected.41b760ed.svg";